import {defineStore} from "pinia";
import {getTranslations, getCrops} from "../Services/seedRateCalculatorDataService";

export const useSeedRateCalculatorStore = defineStore("seedRateCalculatorStore", {
    state: () => ({
        translations: {},
        crops: {},
        currentLanguage: null,
        metric: true,
        calculateSeedVolume: true,
        seedsConversion: true,
        weightConversion: false,
        seed: '',
        activeSeed: '',

        seedRateTargetPopulation: null,
        thousandGrainWeight: null,
        germinationRate: null,
        fieldGermination: null,
        fieldSize: null,
    }),

    getters: {
        seedsPerUnit: (state) => {
            return state.metric ? state.seedRateTargetPopulation * (state.germinationRate * (state.fieldGermination / 100)) / state.thousandGrainWeight : state.plantsPerUnit / state.seedSurvivabilty;
        },
        plantsPerUnit: (state) => {
            return state.metric ? state.plantsPerAreaUnit / 10000 : state.plantsPerAreaUnit / 43560;
        },
        weightPerUnit: (state) => {
            return state.metric ? state.seedRateTargetPopulation * 1000 : state.seedRateTargetPopulation * 454;
        },
        gramsPerSeed: (state) => {
            return state.thousandGrainWeight / 1000
        },
        seedsPerAreaUnit: (state) => {
            return state.weightPerUnit / state.thousandGrainWeight;
        },
        plantsPerAreaUnit: (state) => {
            return state.weightPerUnit / state.gramsPerSeed;
        },
        estimatedSeedVolume: (state) => {
            return (state.fieldSize * state.seedRateTargetPopulation);
        },
        seedPopulation: (state) => {
            return state.seedRateTargetPopulation / (state.germinationRate - (100 - state.fieldGermination)) * 100;
        },
        actualSeedVolumeAreaUnit: (state) => { // M30
            return state.metric ? state.seedPopulation * 10000 : state.seedPopulation * 43560;
        },
        actualSeedVolumeWeightArea: (state) => {
            const seedVolumeWeightArea = state.actualSeedVolumeAreaUnit * state.gramsPerSeed;
            return state.metric ? seedVolumeWeightArea / 1000 : seedVolumeWeightArea * 0.00220462;
        },
        actualSeedVolumeWeight: (state) => {
            return state.actualSeedVolumeWeightArea * state.fieldSize;
        },
        seedSurvivabilty: (state) => {
            return (state.germinationRate - (100 - state.fieldGermination)) / 100;
        },
        isValidForm: (state) => {
            var commonParamsValid =
                state.thousandGrainWeight > 1 &&
                state.germinationRate > 0 &&
                state.fieldGermination >= 0 &&
                state.fieldSize > 0;

            return state.calculateSeedVolume ?
                commonParamsValid && state.seedRateTargetPopulation > 0 :
                commonParamsValid && state.seedRateTargetPopulation > 0;
        },
    },

    actions: {
        async getTranslationsAction() {
            const translations = getTranslations();
            this.translations = translations;
        },

        async getCropsAction() {
            const crops = getCrops();
            this.crops = crops;
        },

        getCurrentLanguage() {
            this.currentLanguage = document.getElementById('currentLanguage').value;
            if (this.currentLanguage === 'ca-en' || this.currentLanguage === 'us-en') {
                this.metric = false;
            }
        },

        convertToImperial() {
            if (this.fieldSize > 0) {
                this.fieldSize = (this.fieldSize * 2.47105381);
            }
            if (this.seedRateTargetPopulation > 0) {
                this.seedRateTargetPopulation = (this.seedRateTargetPopulation * 0.8922);
            }
            if (this.seedRateTargetPopulation > 0) {
                this.seedRateTargetPopulation = Number((this.seedRateTargetPopulation * 10.7639));
            }
        },

        convertToMetric() {
            if (this.fieldSize > 0) {
                this.fieldSize = (this.fieldSize / 2.47105381);
            }
            if (this.seedRateTargetPopulation > 0) {
                this.seedRateTargetPopulation = (this.seedRateTargetPopulation / 0.8922);
            }
            if (this.seedRateTargetPopulation > 0) {
                this.seedRateTargetPopulation = Number((this.seedRateTargetPopulation / 10.7639));
            }
        },

        convertFieldGerminationRate(userInput) {
            this.fieldGermination = 100 - userInput;
        },

        setActiveSeed(seed, TGW, germinationRate, fieldGermination) {
            this.activeSeed = seed;
            if (this.metric !== false) {
                this.thousandGrainWeight = TGW;
            } else {
                this.thousandGrainWeight = (TGW * 0.0352739619);
            }
            this.germinationRate = germinationRate;
            this.fieldGermination = fieldGermination;
        },

        setImperialActive() {
            this.metric = false;
        },

        setMetricActive() {
            this.metric = true;
        },

        setSeedVolumeActive() {
            this.calculateSeedVolume = true;
        },

        setSeedPopulationActive() {
            this.calculateSeedVolume = false;
        },
    },
});